import { LINK_OUTCOME } from './authIdentity';
import { canResumeEvent } from './identity';

export const IN_PARTY_GOOGLE_ACTION = {
  stay: 'stay',
  rejoin: 'rejoin',
};

/**
 * Decide what an in-party "Continue with Google" should do.
 *
 * `linked` / `alreadyGoogle` keep the same Firebase uid, so the current
 * participant row, role, and approval state remain valid.
 *
 * `signedInInstead` is a different uid. The participant array is keyed by
 * uid and guests cannot rewrite another identity's row, so we cannot migrate
 * the anonymous participant onto an already-existing Google account. If that
 * Google uid is already host or a participant of THIS event, stay. Otherwise
 * send them through `/join/:code` rather than silently appending a second
 * participant.
 */
export function resolveInPartyGoogleAuth({ outcome, nextUid, eventData } = {}) {
  if (outcome === LINK_OUTCOME.linked || outcome === LINK_OUTCOME.alreadyGoogle) {
    return { action: IN_PARTY_GOOGLE_ACTION.stay, reason: 'same-uid' };
  }

  if (outcome === LINK_OUTCOME.signedInInstead) {
    if (canResumeEvent(nextUid, eventData)) {
      return { action: IN_PARTY_GOOGLE_ACTION.stay, reason: 'existing-membership' };
    }
    return { action: IN_PARTY_GOOGLE_ACTION.rejoin, reason: 'different-uid' };
  }

  return { action: IN_PARTY_GOOGLE_ACTION.stay, reason: 'no-change' };
}
